import ExperienceBody from 'mk2/apps/wiki/components/ExperienceBody';
import ExperienceFooter from 'mk2/apps/wiki/components/ExperienceFooter';
import ExperienceHeader from 'mk2/apps/wiki/components/ExperienceHeader';
import ExperienceMenu from 'mk2/apps/wiki/components/ExperienceMenu';
import { ArticleEntity, ExperienceEntity } from 'mk2/apps/wiki/schemas';
import * as React from 'react';
import styles from './Experience.mscss';

interface OwnProps {
    experience: ExperienceEntity;
    article: ArticleEntity;
    isMobile: boolean;
    hasMenu: boolean;

    onToggleMenuMore?(commentId: number);
}
export default class Experience extends React.Component<OwnProps> {

    public render() {
        const {
            experience, onToggleMenuMore, hasMenu, article,
        } = this.props;

        return (
            <div
                id={`experience-${experience.id}`}
                className={styles.Experience}
            >
                <div className={styles.Experience__wrapper}>
                    <ExperienceHeader
                        className={styles.Experience__wrapper__header}
                        experience={experience}
                    />

                    {hasMenu &&
                        <ExperienceMenu
                            className={styles.Experience__wrapper__dropdownMenu}
                            experience={experience}
                            onToggleMenuMore={onToggleMenuMore}
                        />
                    }

                    <ExperienceBody
                        experience={experience}
                        article={article}

                    />
                </div>

                <ExperienceFooter
                    experience={experience}
                />
            </div>
        );
    }
}
